export class ThemeMO {
	key: string;
	themeTitle: string;
	themeQuestion: string;
	ratings: string[];
	customeThemeRatings: string[];

	constructor(
		key: string = '',
		themeTitle: string = '',
		themeQuestion: string = '',
		ratings: string[] = [],
		customeThemeRatings: string[] | null = null,
	) {
		this.key = key;
		this.themeTitle = themeTitle;
		this.themeQuestion = themeQuestion;
		this.ratings = ratings;
		this.customeThemeRatings = customeThemeRatings;
	}
}
